import { useSelector } from 'react-redux';
import { checkPermission } from '../util/permissionHelper';

/**
 * Custom hook to check permissions in components.
 * 
 * @returns {Object} - An object containing the 'can' function.
 */

export const usePermission = () => {
    const { admin, loginType, permissions } = useSelector((state) => state.admin);

    /**
     * Checks if the user can perform a specific action on a module.
     * 
     * @param {string} moduleName - The name of the module.
     * @param {string} actionName - The name of the action (e.g., 'List', 'Create', 'Edit', 'Delete').
     * @returns {boolean} - True if permitted, false otherwise.
     */
    const can = (moduleName, actionName) => {
        return checkPermission(admin, loginType, permissions, moduleName, actionName);
    };

    return { can };
};
